(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSwiper(section) {
      var blocks = section.querySelector('.text-with-icons__blocks');
      if (!blocks) return;

      var count = parseInt(blocks.getAttribute('data-block-count'), 10);
      if (!count || count <= 1) return;

      /* Skip if dots already injected (editor re-init guard) */
      if (section.querySelector('.twi-dots')) return;

      var cards = blocks.querySelectorAll('.text-with-icons__block');

      /* Build dots row */
      var dotsEl = document.createElement('div');
      dotsEl.className = 'twi-dots';

      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.className = 'twi-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
        dotsEl.appendChild(dot);
      }

      /* Insert after the blocks container */
      blocks.parentNode.insertBefore(dotsEl, blocks.nextSibling);

      var dots = dotsEl.querySelectorAll('.twi-dot');

      /* Tap dot → scroll to card */
      dots.forEach(function (dot, idx) {
        dot.addEventListener('click', function () {
          blocks.scrollTo({ left: cards[idx].offsetLeft, behavior: 'smooth' });
        });
      });

      /* Scroll → update active dot */
      var rafId = null;
      blocks.addEventListener('scroll', function () {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          var active = 0;
          var minDist = Infinity;
          cards.forEach(function (card, i) {
            var dist = Math.abs(card.offsetLeft - blocks.scrollLeft);
            if (dist < minDist) { minDist = dist; active = i; }
          });
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === active);
          });
        });
      });
    }

    /* Init all text-with-icons sections on page load */
    document.querySelectorAll('.text-with-icons').forEach(initSwiper);

    /* Re-init when Shopify theme editor reloads a section */
    document.addEventListener('shopify:section:load', function (evt) {
      var twi = evt.target.querySelector('.text-with-icons');
      if (twi) initSwiper(twi);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
